import React from 'react'

import { CustomTheme } from '@masfront/common-b2c'

import { Box } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import useBrandStyles from './ProductStatusDetailBrandStyles'

import { SubscriptionStatusGroup } from '~/customer/model/customer.model'

const useStyles = makeStyles((theme: CustomTheme) => {
  return createStyles({
    wrapper: {
      position: 'relative',
    },
    triangle: {
      position: 'absolute',
      right: '1px',
      borderTop: `${theme.spacing(3)}px solid transparent`,
      borderBottom: `${theme.spacing(3)}px solid transparent`,
      marginRight: '-9px',
    },
  })
})

interface TriangleDividerProps {
  statusGroup: SubscriptionStatusGroup
}

function TriangleDivider({ statusGroup }: TriangleDividerProps) {
  const classes = useStyles()
  const brandClasses = useBrandStyles({ statusGroup })

  return (
    <Box className={classes.wrapper}>
      <Box className={`${classes.triangle} ${brandClasses.triangle}`} />
    </Box>
  )
}

export default TriangleDivider
